import { Link, Navigate, useParams } from "react-router-dom";
import { useBinderEntry } from "../properties/binder-api.js";
import { BinderEntryForm } from "../properties/BinderEntryForm.js";

export function BinderEntryEdit() {
  const { id, entryId } = useParams<{ id: string; entryId: string }>();
  const { data: entry, isLoading, error } = useBinderEntry(id, entryId);

  if (!id || !entryId) return <Navigate to="/app/properties" replace />;
  if (isLoading) return <p className="p-4 text-sm text-slate-500">Loading…</p>;
  if (error || !entry) {
    return (
      <div className="p-4">
        <p className="rounded bg-rose-50 p-3 text-sm text-rose-900">Entry not found.</p>
        <Link to={`/app/properties/${id}`} className="mt-3 inline-block text-sm text-teal-700">
          Back to property
        </Link>
      </div>
    );
  }

  return <BinderEntryForm propertyId={id} mode="edit" initial={entry} />;
}
